module.exports = __webpack_public_path__ + "img/rise_jeans_low.c899e70a.jpg";